import React from 'react';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { catalogBibShape, reviewShape } from '@bibliocommons/bc-prop-types';
import Divider from 'app/components/bibs/shared/Divider';
import { SecondaryLink } from '@bibliocommons/base-links';
import BibSubPage from 'app/components/bibs/subpages/BibSubPage';
import { CONTENT_PROVIDERS } from 'app/constants/BibConstants';
import Review from 'app/components/bibs/shared/Review';

import './AllReviewsPage.scss';

export class AllReviewsPage extends React.PureComponent {
  renderReview = review => <Review review={review} key={review.get('id')} />;

  renderReviews() {
    const { reviews, catalogBib } = this.props;
    const iDreamBooksReviews = reviews.filter(review => review.get('providerURI') === CONTENT_PROVIDERS.I_DREAM_BOOKS);
    const otherReviews = reviews.filter(review => review.get('providerURI') !== CONTENT_PROVIDERS.I_DREAM_BOOKS);

    return reviews.size ? (
      <div>
        {iDreamBooksReviews.map(this.renderReview)}
        {iDreamBooksReviews.size > 0 && (
          <div>
            <div className="all-reviews-page__more-reviews">
              <FormattedMessage
                id="read_more_reviews"
                values={{
                  title: catalogBib.getIn(['brief', 'title']),
                  link: (
                    <SecondaryLink href={iDreamBooksReviews.getIn([0, 'fullDetailsURI'])} dataKey="more-reviews">
                      iDreamBooks.com
                    </SecondaryLink>
                  )
                }}
              />
            </div>
            {iDreamBooksReviews.size > 0 && otherReviews.size > 0 && <Divider />}
          </div>
        )}
        {otherReviews.map(this.renderReview)}
      </div>
    ) : (
      <div className="no-content-placeholder">
        <FormattedMessage id="no_reviews" />
      </div>
    );
  }

  render() {
    const { catalogBib, reviews } = this.props;

    return (
      <div className="cp-all-reviews-page">
        <BibSubPage catalogBib={catalogBib} headerLocKey="reviews" headerCount={reviews.size}>
          <Divider />
          {this.renderReviews()}
        </BibSubPage>
      </div>
    );
  }
}

AllReviewsPage.propTypes = {
  catalogBib: catalogBibShape.isRequired,
  reviews: ImmutablePropTypes.listOf(reviewShape).isRequired
};

export default AllReviewsPage;
